import axios from '../utils/axios'

// 获取活动信息
export const GetActiveList = (data) => {
        return axios.post(`/api/index/activity`, data)
    }
    // 首页初始化
export const HomeDataInit = (data) => {
        return axios.post(`/api/index/init`, data)
    }
    // 根据线路主键获取详细信息
export const GetLineDetail = (data) => {
    return axios.post(`/api/index/line/info`, data)
}

// 获取景区线路列表
export const GetLineList = (data) => {
    return axios.post(`/api/index/lines`, data)
}

// 获得点位列表
export const GetPointList = (data) => {
    return axios.post(`/api/index/point`, data)
}

// 获得点位详细信息

export const GetPointDetail = (data) => {
    return axios.post(`/api/index/point/info`, data)
}


// 获得专题详细信息
export const GetSpecialInfo = (data) => {
    return axios.get(`/api/index/specialInfo?id=${data.id}&language=${data.language}`)
}

// 根据专题类型获得专题信息列表
export const GetSpecialByType = (data) => {
    return axios.get(`/api/index/specialType?type=${data.type}&language=${data.language}`)
}

// 获得全部专题类型
export const GetAllSpecialType = (data) => {
    return axios.post(`/api/index/specialType`, data)
}

// 获取全部专题列表
export const GetAllSpecialList = (data) => {
    return axios.post(`/api/index/specials`, data)
}